<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف/ویرایش قالب پیام گروهی</v-card-subtitle>
<v-spacer/>
        <v-card-text>


          <v-form  ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>

              <v-col
                  cols="12"
                  sm="4"
                  >

                <v-text-field
                    label="نام قالب به انگلیسی"
                    outlined
                    dense
                    :error-messages="getError('templateEn')"
                    v-model="model.templateEn"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                  >

                <v-text-field
                    label="نام قالب به فارسی"
                    outlined
                    dense
                    :error-messages="getError('templateFa')"
                    v-model="model.templateFa"
                />

              </v-col>
              <v-col
                  cols="12"
                  sm="4"
                 >

                <v-text-field
                    label="تعداد ستون اکسل "
                    outlined
                    dense
                    type="number"
                    :error-messages="getError('countCell')"
                    v-model="model.countCell"
                />
</v-col>

              <v-col
                  cols="12"
                  sm="12"
                  >

                <v-textarea
                    label="متن پیام"
                    outlined
                    dense
                    :error-messages="getError('message')"
                    v-model="model.message"
                />
              </v-col>

            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                 small
                 depressed
                  color="primary"
                  class=" pr-1 pl-1"
                  type="submit"
                 :loading="loading"
              >
                ذخیره
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import KavehNegar_se from "@/views/define/kavehNegar/KavehNegar_se";



export default {

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {
      bindingErrors: [],
      loading: false,
      valid: true,

    }
  },




  methods: {
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors=[]
      this.loading=false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('KavehNegar' )


    },


    save() {
      this.loading=true
      this.bindingErrors = []
        KavehNegar_se.save(this.model).then(response => {
            if (response && response.status === 200) {
            this.$snack({type: 'success'})
            this.closed()
          }else if (response && response.response.status === 400) {
            this.loading=false
            this.bindingErrors = response.response.data;
          }
        })

    },

  },



}
</script>


